import { render } from "./election-voter-home-card.vue?vue&type=template&id=54598dab"
import script from "./election-voter-home-card.vue?vue&type=script&lang=js"
export * from "./election-voter-home-card.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__